import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { Button, Dropdown, Form, OverlayTrigger, ProgressBar, Breadcrumb } from "react-bootstrap";
import { BsFileEarmarkZip, BsFileEarmarkSpreadsheet, BsFillCaretDownFill, BsFillCaretUpFill, BsFillGridFill, BsFilter, BsEye } from "react-icons/bs";
import { BiDownload, BiPencil, BiBullseye } from "react-icons/bi";
import { FaList } from "react-icons/fa";
import './DataViewGrid.scss';
import { LS_AUTHORITY_KEY } from "../../../core/constants/common";
import { LoaderContext } from "../../../App";
import KPIService from "../../../core/service/KPIService";
import { useNavigate } from "react-router-dom";
import { FcFinePrint } from "react-icons/fc";

const DataViewGrid = ({ t }) => {

	const navigate = useNavigate();
	const lsData = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
	const companyId = lsData.profile.company.id;
	const { setLoaderDisplay } = useContext(LoaderContext);
	const [goals, setGoals] = useState([]);
	const [currentPage, setCurrentPage] = useState(0);
	const [hasMore, setHasMore] = useState(true);
	const itemsPerPage = 15;

	useEffect(() => {
		fetchGoals(currentPage);
	}, []);

	useEffect(() => {
		let lastScrollTime = 0;

		const handleScroll = () => {
			const now = Date.now();
			const bottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 100;

			if (bottom && hasMore && now - lastScrollTime > 200) {
				lastScrollTime = now;

				setCurrentPage(prevPage => {
					const nextPage = prevPage + 1;
					fetchGoals(nextPage);
					return nextPage;
				});
			}
		};

		window.addEventListener('scroll', handleScroll);

		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, [hasMore]);

	const fetchGoals = (pageNumber) => {
		setLoaderDisplay(true);
		KPIService.listGoalsPaged(companyId, 'SHORT_TERM', pageNumber, itemsPerPage)
			.then(res => {
				setLoaderDisplay(false);
				if (res.status !== 200) return;

				if (res.data.data) {
					const newGoals = res.data.data.content || [];
					if (newGoals.length < itemsPerPage) {
						setHasMore(false);
					}
					setGoals(prevGoals => {
						const existingGoalIds = prevGoals.map(goal => goal.id);
						const goalsToAdd = newGoals.filter(goal => !existingGoalIds.includes(goal.id));
						return [...prevGoals, ...goalsToAdd];
					});

				} else {
					setHasMore(false);
				}
			})
			.catch(err => {
				setLoaderDisplay(false);
				setHasMore(false);
			});
	};

	const navigateToKpis = (goal) => {
		navigate(`/company_admin/kpistatusview/goal/${goal.id}`, { state: { goal } });
	}

	const renderEmptyDataLabel = () => {
		return (
			<div className="Nodatafound_box DataViewGrid_empty">
				<div className="DataViewGrid_empty_inner text-center"><FcFinePrint className="me-2" />{t("Nodatafound.label")}</div>
			</div>
		)
	};

	const getGoalStatusClass = (status) => {
		switch (status) {
			case 'Exceeded target':
				return 'exceeded_target';
			case 'Achieved':
				return 'achieved';
			case 'Off-track':
				return 'off_track';
			case 'At risk':
				return 'at_risk';
			default:
				return '';
		}
	};

	const getGoalStatusText = (status) => {
		switch (status) {
			case 'ON_TRACK':
				return 'On Track';
			case 'OFF_TRACK':
				return 'Off Track';
			case 'AT_TRACK':
				return 'At Track';
			default:
				return status;
		}
	};

	return (
		<div className="DataViewGrid DataViewGrid_wrapper">
			<div className="DataViewGrid_header List_header mb-1">
				<div>
					<h5 className="DataViewGrid_title MH">{t("Status.label")}</h5>
				</div>
				{/* <div className="header-actions">
					<div className="ToggleBtn">
						<Form.Check
							className="toggle-switch"
							inline
							label="Status"
							name="assessType"
							type="radio"
							id="inline-radio-2"
							checked
						/>
						<Form.Check
							className="toggle-switch"
							inline
							label="Data View"
							name="assessType"
							type="radio"
							id="inline-radio-1"
						/>
					</div>
					<button className="btn btn-headbtn" >
						<BsFilter />
					</button>

					<Dropdown>
						<Dropdown.Toggle variant="headbtn" id="dropdown-basic">
							<BiDownload />
						</Dropdown.Toggle>

						<Dropdown.Menu>
							<OverlayTrigger>
								<Dropdown.Item>
									<BsFileEarmarkZip className="me-1" /> {t("Documents&File.label")}
								</Dropdown.Item>
							</OverlayTrigger>
							<OverlayTrigger>
								<Dropdown.Item>
									<BsFileEarmarkSpreadsheet className="me-1" /> {t("Spreadsheet.label")}
								</Dropdown.Item>
							</OverlayTrigger>
						</Dropdown.Menu>
					</Dropdown>
				</div> */}
			</div>
			<div className="DataViewGrid_card DataViewGrid_list">
				<div className="DataViewGrid_row row m-0">
					{
						goals?.map(goal => (
							<div className="DataViewGrid_col col-md-3 p-2" key={goal.id}>
								<div className={`card GoalCard DataViewGrid_goalCard ${getGoalStatusClass(goal.status)}`}>
									<div className="card-body DataViewGrid_goalCard_body" onClick={() => navigateToKpis(goal)}>

										<div className="DataViewGrid_goalCard_content">
											<div className="GoalCard_header0 DataViewGrid_goalCard_top">
												<span className="badge DataViewGrid_goalCard_badge">
													{getGoalStatusText(goal.status)}
												</span>
											</div>
											<div className="GoalCard_category DataViewGrid_goalCard_category">
												{goal.category}
											</div>
											<h5 className="DataViewGrid_goalCard_title">{goal.name}</h5>
											<p className="DataViewGrid_goalCard_desc">{goal.description}</p>
											<div className="unit DataViewGrid_goalCard_dates">
												{goal.timelineStart ? moment(goal.timelineStart).format('MMM DD, YYYY') : ''} - {goal.timelineEnd ? moment(goal.timelineEnd).format('MMM DD, YYYY') : ''}
											</div>
										</div>
										<div className="DataViewGrid_goalCard_footer">
											<h4 className="DataViewGrid_goalCard_percent">{goal.percentage}%</h4>
											<ProgressBar now={goal.percentage} className="DataViewGrid_goalCard_progress" />
										</div>
									</div>

								</div>
							</div>
						))
					}
					{
						goals.length === 0 &&
						renderEmptyDataLabel()
					}
				</div>
			</div>
		</div>
	);
};






export default withTranslation()(DataViewGrid);